import React from 'react';
import { useAppContext } from '../store/AppContext';
import SafeIcon from '../common/SafeIcon';
import { FiUsers, FiGlobe, FiTarget, FiActivity } from 'react-icons/fi';
import { motion } from 'framer-motion';

const StatCard = ({ title, value, icon, color }) => (
  <motion.div 
    initial={{ opacity: 0, y: 20 }}
    animate={{ opacity: 1, y: 0 }}
    className="bg-white rounded-xl p-6 shadow-sm border border-slate-100 flex items-center"
  >
    <div className={`p-4 rounded-lg ${color} mr-4`}>
      <SafeIcon icon={icon} className="text-2xl text-white" />
    </div>
    <div>
      <p className="text-sm font-medium text-slate-500">{title}</p>
      <h3 className="text-2xl font-bold text-slate-800">{value}</h3>
    </div>
  </motion.div>
);

const Dashboard = () => {
  const { data, t } = useAppContext();

  const stats = {
    clients: data.clients.length,
    websites: data.clients.reduce((acc, c) => acc + (c.websites?.length || 0), 0),
    keywords: data.clients.reduce((acc, c) => 
      acc + (c.websites?.reduce((wAcc, w) => wAcc + (w.keywords?.length || 0), 0) || 0)
    , 0)
  };

  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-bold text-slate-800">{t('dashboard')}</h1>
      
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <StatCard title={t('totalClients')} value={stats.clients} icon={FiUsers} color="bg-blue-600" />
        <StatCard title={t('totalWebsites')} value={stats.websites} icon={FiGlobe} color="bg-indigo-500" />
        <StatCard title={t('totalKeywords')} value={stats.keywords} icon={FiTarget} color="bg-teal-500" />
      </div>

      <div className="bg-white rounded-xl shadow-sm border border-slate-100 p-6 mt-8">
        <div className="flex items-center mb-4">
          <SafeIcon icon={FiActivity} className="text-slate-400 mr-2" />
          <h2 className="text-lg font-semibold text-slate-800">{t('recentActivity')}</h2>
        </div>
        <div className="text-slate-500 text-sm">
          {stats.clients === 0 ? t('noData') : (
            <div className="space-y-4">
              <p>Platform is active and tracking {stats.keywords} keywords across {stats.websites} distinct domains for {stats.clients} clients.</p>
              <p>System status: <span className="text-green-500 font-medium">Operational</span></p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Dashboard;